'use client';

import { c as _c } from "react/compiler-runtime";
import ContentAnalytics from '@/components/shared/ContentAnalytics';
import { LandingPageSplitContext } from '@/app/l/_lib/landingPagePageTypes';
import { LandingPageFirebaseType } from '@poppy/firebase';
interface LandingPageAnalyticsProps {
  landingPageDetails: Pick<LandingPageFirebaseType, 'nodeId' | 'pageSlug' | 'title' | 'clientFeatures' | 'pageType'>;
  isEditMode: boolean;
  ownerUserId: string;
  currentUserId: string | null;
  isGuestUser?: boolean;
  splitContext?: LandingPageSplitContext;
}
const LandingPageAnalytics = t0 => {
  const $ = _c(7);
  const {
    landingPageDetails,
    isEditMode,
    ownerUserId,
    currentUserId,
    isGuestUser: t1,
    splitContext
  } = t0;
  const isGuestUser = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentUserId || $[1] !== isEditMode || $[2] !== isGuestUser || $[3] !== landingPageDetails || $[4] !== ownerUserId || $[5] !== splitContext) {
    t2 = <ContentAnalytics contentDetails={landingPageDetails} isEditMode={isEditMode} ownerUserId={ownerUserId} currentUserId={currentUserId} isGuestUser={isGuestUser} pageType={landingPageDetails.pageType} splitContext={splitContext} />;
    $[0] = currentUserId;
    $[1] = isEditMode;
    $[2] = isGuestUser;
    $[3] = landingPageDetails;
    $[4] = ownerUserId;
    $[5] = splitContext;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default LandingPageAnalytics;